import styled from 'styled-components';
import { FontSize, FontWeight, device } from 'commons';

export const Main = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  gap: 25px;
  overflow-y: scroll;
  padding: 20px 48px 50px;

  @media (max-width: ${device.tablet}px) {
    padding: 20px 28px 50px;
  }

  .danger {
    color: ${({ theme }) => theme.danger_500};
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 1200px;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 78px;
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(268px, 1fr));
  gap: 16px;

  @media (max-width: ${device.tablet}px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const Title = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;

  span {
    color: ${({ theme }) => theme.danger_300};
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 4px;
  min-width: 268px;
`;

export const Label = styled.label`
  font-size: ${FontSize.font12};
  font-weight: ${FontWeight.regular};

  span {
    color: ${({ theme }) => theme.danger_300};
  }
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const FormRow = styled.div<{ $full?: boolean }>`
  height: 100%;
  width: ${({ $full }) => ($full ? '100%' : 'fit-content')};
  display: flex;
  gap: 16px;
`;

export const RadioWrapper = styled.label`
  height: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  input[type='radio'] {
    width: 20px;
    height: 20px;
    cursor: pointer;
    border-color: red;
  }

  .error {
    color: ${({ theme }) => theme.danger_500};
  }
`;
